import React from 'react';
import AddAgentComponent from '../../../Components/Agent/AddAgent';

export default function AddAgent() {
    return (
        <div className='page-body'>
            <AddAgentComponent />
        </div>
    );
}